export default {"src":"/_next/static/media/vendor-risk-management-tprm.936ea480.svg","height":464,"width":461,"blurWidth":0,"blurHeight":0};